import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import styles from './Footer.module.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();

  const handleServiceClick = (e, path) => {
    e.preventDefault();
    const [pathname, hash] = path.split('#');
    if (location.pathname === pathname && hash) {
      // Already on the page, just scroll
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate(path);
    }
  };

  const navLinks = [
    { label: 'Главная', path: '/' },
    { label: 'О компании', path: '/about' },
    { label: 'Услуги', path: '/services' },
    { label: 'Контакты', path: '/contacts' },
  ];

  const serviceLinks = [
    { label: 'Импорт', path: '/services#services' },
    { label: 'Экспорт', path: '/services#export' },
    { label: 'Таможенное оформление', path: '/services#services' },
    { label: 'Финансовое сопровождение', path: '/services#services' },
  ];

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.grid}>
          {/* Column 1: Logo + Description + Contacts */}
          <div className={styles.column}>
            <Link to="/" className={styles.logo}>
              Советник
            </Link>
            <p className={styles.description}>
              Профессиональные услуги в сфере внешнеэкономической деятельности.
              Сопровождение импортных и экспортных операций, таможенное оформление
              и консультации.
            </p>
            <div className={styles.contactInfo}>
              <a href="mailto:info@konsultant-sovetnik.ru" className={styles.contactLink}>
                info@konsultant-sovetnik.ru
              </a>
              <a href="tel:+79109369889" className={styles.contactLink}>
                +7 (910) 936-98-89
              </a>
            </div>
          </div>

          {/* Column 2: Navigation */}
          <div className={styles.column}>
            <h3 className={styles.columnTitle}>Навигация</h3>
            <ul className={styles.linkList}>
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className={styles.link}>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Services */}
          <div className={styles.column}>
            <h3 className={styles.columnTitle}>Услуги</h3>
            <ul className={styles.linkList}>
              {serviceLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className={styles.link}
                    onClick={(e) => handleServiceClick(e, link.path)}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Contacts */}
          <div className={styles.column}>
            <h3 className={styles.columnTitle}>Контакты</h3>
            <div className={styles.hours}>
              <span className={styles.hoursLabel}>Режим работы:</span>
              <span>Пн-Пт 9:00-18:00</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className={styles.bottomBar}>
        <div className={styles.container}>
          <div className={styles.bottomContent}>
            <p className={styles.copyright}>
              &copy; {currentYear} ООО Советник. Все права защищены.
            </p>
            <div className={styles.legalLinks}>
              <Link to="/privacy" className={styles.legalLink}>
                Политика конфиденциальности
              </Link>
              <Link to="/terms" className={styles.legalLink}>
                Пользовательское соглашение
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
